


































































import { defineComponent, computed } from '~/utils/nuxt3-migration'
import CDragScroll from '~/components/shared/configurable/CDragScroll.vue'
import Searchbar from '~/components/shared/classified/search/searchbar/Searchbar.vue'
import IndexCategoryIcon from '~/components/car/classifieds/index/jumbotron/IndexCategoryIcon.vue'
import { CIcon } from '~/icons/types'
import { CategoryId } from '~/models/category/types'
import { ciJobs } from '~/icons/source/thin/jobs'
import { ciRealEstate } from '~/icons/source/thin/real-estate'
import { ciVehicles } from '~/icons/source/thin/vehicles'
import { ciPartsAccessories } from '~/icons/source/thin/parts-accessories'
import { formatNumber } from '~/utils/number'
import { mapGetters, mapState } from 'vuex'
import { INDEX_NS } from '~/store/modules/shared/index/state'
import ClassifiedQuickSearchPlotFacets from '~/components/car/classifieds/quick-search/ClassifiedQuickSearchPlotFacets.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { ciMarketplace } from '~/icons/source/thin/marketplace'
import SmartSearchbar from '~/components/shared/classified/search/searchbar/SmartSearchbar.vue'
import { useNamespacedStore } from '~/compositions/store'
import { AccessToggleName } from '~/models/user/access-toggles'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'

interface IndexSearchableCategory {
  icon: CIcon
  iconActive: CIcon
  title: string
  catId: number
}
export default defineComponent({
  components: {
    SmartSearchbar,
    ClassifiedQuickSearchPlotFacets,
    IndexCategoryIcon,
    Searchbar,
    CDragScroll
  },
  data() {
    return {
      selectedCategory: CategoryId.VEHICLES
    }
  },
  setup() {
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const userHasAccessTo = userGetters('userHasAccessTo')
    const userHasAccessToSmartSearchbar = computed(() => {
      return userHasAccessTo(AccessToggleName.SMART_SEARCHBAR)
    })

    return {
      userHasAccessToSmartSearchbar
    }
  },
  computed: {
    ...mapState(INDEX_NS, {
      classifiedsCount: state => state.count
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    isTouchDevice() {
      return process.client && 'ontouchstart' in window
    },
    vehiclesCatId() {
      return CategoryId.VEHICLES
    },
    partsCatId() {
      return CategoryId.PARTS
    },
    xymaCatId() {
      return CategoryId.XYMA
    },
    plotCatId() {
      return CategoryId.PLOT
    },
    jobsCatId() {
      return CategoryId.JOBS
    },
    placeholder() {
      switch (this.selectedCategory) {
        case this.vehiclesCatId:
          return this.$t('what vehicle are you looking for?')
        case this.partsCatId:
          return this.$t('what part are you looking for?')
        default:
          return this.$t('what are you looking for?')
      }
    },
    indexSearchableCategories(): IndexSearchableCategory[] {
      return [
        {
          icon: ciVehicles,
          title: this.$t('vehicles') as string,
          catId: this.vehiclesCatId
        },
        {
          icon: ciPartsAccessories,
          title: this.$t('parts') as string,
          catId: this.partsCatId
        },
        {
          icon: ciMarketplace,
          title: this.$t('classifieds::xyma') as string,
          catId: this.xymaCatId
        },
        {
          icon: ciRealEstate,
          title: this.$t('real estate') as string,
          catId: this.plotCatId
        },
        {
          icon: ciJobs,
          title: this.$t('jobs') as string,
          catId: this.jobsCatId
        }
      ]
    },
    formattedClassifiedCount() {
      return formatNumber(this.classifiedsCount)
    }
  },
  mounted() {
    if (!this.isTouchDevice) {
      this.$refs.searchbar.silentFocus()
    }
  },
  methods: {
    async selectCategory(catId: CategoryId) {
      this.selectedCategory = catId
      this.$emit('select-category', this.selectedCategory)
      const elem = this.$refs['cat' + catId][0]

      if (elem.$el) {
        this.$refs.scroller.scrollToElementIfOverflown(elem.$el)
      }

      await this.$nextTick()

      if (
        this.$refs.searchbar?.onRootCategoryChange &&
        !this.userHasAccessToSmartSearchbar
      ) {
        this.$refs.searchbar.onRootCategoryChange()
      }
    }
  }
})
